const sendMessage = <T extends keyof SendActions>(action: T, extra: SendActions[T]) => {
  const json = { action, extra }
  try {
    ;(window as any).ReactNativeWebView.postMessage(JSON.stringify(json))
    console.log('sendMessageToR1App json', json)
  } catch (e) {}
}

export default sendMessage

/** 订单详情类型 */
export enum OrderDetailType {
  normal = 0,
  onlyPay,
}
/** H5向RN发送消息 */
export type SendActions = {
  RouteOrderDetail: {
    orderCode: string
    type: OrderDetailType.onlyPay
  }
}
